import { Button } from '../../atoms/Button';
import { Typography } from '../../molecules/Typography';
import { useCoursesStore } from '../../../../modules/Courses/stores/courseStore';
import { useAccessControlStore } from '../../../stores/accessControlStore';
import { getSalesLink } from '../../../accessControl/salesLink';
import LockSvg from './svg';
import { Link } from 'react-router-dom';

interface ILock {
  isCourse?: boolean;
  redirectLink?: string;
}

export default function Lock({ isCourse = false, redirectLink }: ILock) {
  const platformModules = useAccessControlStore(
    (state) => state.platformModules
  );

  const redirectTo = () => {
    window.open(redirectLink ?? getSalesLink(platformModules));
  };

  if(isCourse) {
    const { loadedCourse } = useCoursesStore();

    if (!loadedCourse) {
      return <div>Carregando...</div>;
    }

    const currentYear = new Date().getFullYear();
    const yearCourse = loadedCourse?.year;
    const isRegular = loadedCourse?.kind === 'regular';

    if (isRegular && yearCourse < currentYear) {
      return (
        <div className='m-auto mt-10 w-fit rounded-[16px] bg-color-lightest px-4 py-8 shadow-level-1'>
          <Typography
            size='h4'
            weight='bold'
            className=' mb-8 mt-12 px-2 text-center text-base'
          >
            Opa, este curso faz parte de uma versão mais antiga do nosso
            conteúdo, que não está mais disponível.
          </Typography>
          <Typography className='mb-8 px-2 text-center'>
            Para que você tenha a melhor experiência de estudo, recomendamos que
            acesse os cursos mais recentes, com informações aprimoradas.
          </Typography>
          <Typography className='mb-8 px-2 text-center'>
            <Typography className="mb-4 font-semibold">Para trocar de curso e se matricular em um curso mais atual é fácil: <br/></Typography>
            <Link
              className='font-bold text-color-brand-primary underline'
              to={`/cursos/${loadedCourse.slug}/detalhes`}
            >
              Clique aqui
            </Link>{' '} para acessar a área de gerenciamento do seu curso; <br/>
            Em seguida, clique em  <b>{' "Abandonar curso"'}</b>; <br />
            Depois disso, volte para a lista de cursos regulares, escolha o
            curso que deseja iniciar e clique em <b>{'"Fazer Matrícula"'}</b>.
          </Typography>
        </div>
      );
    }
  }

  return (
    <div className='m-auto mt-10 w-fit rounded-[16px] bg-color-lightest px-4 py-8 shadow-level-1'>
      <LockSvg />
      <Typography
        size='h4'
        weight='bold'
        className=' mt-12 px-2 text-center text-base'
      >
        Opa, esse conteúdo é exclusivo para alunos assinantes...
      </Typography>
      <Typography className='mb-4 mt-8 px-2 text-center'>
        Mas não fica triste, não!
      </Typography>
      <Typography className='mb-8 px-2 text-center'>
        Você pode garantir acesso completo aos conteúdos e estudar com a <br />
        Plataforma do Aprova clicando no botão abaixo ;)
      </Typography>
      <Button full onClick={redirectTo}>
        Quero acesso completo
      </Button>
    </div>
  );
}
